import * as React from "react";
import {
  Autocomplete as AutocompleteMUI,
  SxProps,
  Theme,
  UseAutocompleteProps,
} from "@mui/material";
import TextField from "../atoms/TextField";

interface AutocompleteProps<T> {
  options: T[];
  value: T | null;
  onChange?: (e: React.SyntheticEvent<Element, Event>, value: T | null) => void;
  error?: boolean;
  errorLabel?: string;
  label?: string;
  sx?: SxProps<Theme>;
}

export const Autocomplete = <T,>(
  props: AutocompleteProps<T> &
    UseAutocompleteProps<T, undefined, boolean | undefined, undefined>
) => {
  const {
    options,
    value,
    onChange,
    label,
    error,
    errorLabel,
    sx,
    ...baseProps
  } = props;
  return (
    <AutocompleteMUI
      {...baseProps}
      sx={sx}
      options={options}
      autoHighlight
      value={value || undefined}
      onChange={(e, value) => {
        onChange && onChange(e, value);
      }}
      key={JSON.stringify(value)}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            inputProps={{
              style: { marginLeft: 10 },
              ...params.inputProps,
            }}
            label={label || ""}
            error={error}
            sx={{ border: "none" }}
            errorLabel={error ? errorLabel : ""}
            minWidth="100%"
          />
        );
      }}
    />
  );
};
